import type {TrackDispatcher} from '@gaia/hooks/useTracks';
import compact from 'lodash/compact';
import keyBy from 'lodash/keyBy';

export default function (
    action: ArchiveWaypointAction,
    setWaypoints: React.Dispatch<React.SetStateAction<{[localId: string]: Waypoint}>>,
    trackPoints: {[localId: string]: Waypoint},
    trackDispatcher: TrackDispatcher
) {
    const data = Array.isArray(action.data) ? action.data : [action.data];

    setWaypoints((latestWaypoints) => archiveWaypoints(data, latestWaypoints));

    const archivedRouteWaypoints = compact(data.map((localId) => trackPoints[localId]));

    // When a route waypoint is archived it is converted back to a normal route point so that
    // the route geometry is not changed
    archivedRouteWaypoints.forEach((waypoint) => {
        trackDispatcher({
            type: 'updatePointProperties',
            properties: {
                localId: waypoint.properties.localId,
                trackLocalId: trackPoints[waypoint.properties.localId].properties.trackLocalId!,
                attr: 'route',
            },
        });
    });

    return data;
}

export function archiveWaypoints(data: string[], waypoints: Record<string, Waypoint>) {
    const archivedWaypoints = compact(data.map((localId) => waypoints[localId])).map(
        (waypoint) => ({
            ...waypoint,
            properties: {
                ...waypoint.properties,
                archived: true,
                // If a waypoint doesn't have an id that means it was never synced. This will
                // only occur if a waypoint was created and the user selected "Cancel"
                deleted: !waypoint.properties.id,
            },
        })
    );

    return {
        ...waypoints,
        ...keyBy(archivedWaypoints, (waypoint) => waypoint.properties.localId),
    };
}
